import {addQueryToPath} from '../../../../../../libs/shared/core/src/helpers/browser/urlHelpers';
import {
  ApiKnowledgeBaseArticlesUpdated,
  parseKnowledgeBaseAnalyticsArticlesUpdated,
} from '../../../../../../libs/shared/core/src/models/api/knowledgeBaseAnalyticsArticlesUpdatedModel';
import {postApiAsync} from '../../../../../../libs/shared/core/src/services/http/http';
import {buildAppQueries} from '../../../../../../libs/shared/core/src/services/query/appQueryHelpers';
import {
  buildAnalyticsAutomationQueryFromState,
  makeAnalyticsApiPath,
} from '../../../../../store/panels/analytics/analyticsPanelHelpers';

/*
 * Query.
 */

export const knowledgeBaseReportArticlesUpdatedQueries = buildAppQueries(
  'knowledgeBaseReportArticlesUpdated',
  {
    byFilters: (
      filters: ReturnType<typeof buildAnalyticsAutomationQueryFromState>,
      selectedNamespace: string,
    ) => ({
      queryKey: [JSON.stringify(filters)],
      queryFn: async ({company, cancelToken, pageParam}) =>
        postApiAsync(
          ApiKnowledgeBaseArticlesUpdated,
          addQueryToPath(
            `${makeAnalyticsApiPath(company.url, selectedNamespace)}/metrics/knowledge_base/article_updates`,
            {next_page_token: pageParam},
          ),
          filters,
          {
            cancelToken,
          },
        ),
      getNextPageParam: (lastPage: ReturnType<typeof parseKnowledgeBaseAnalyticsArticlesUpdated>) =>
        lastPage.articlesUpdated.next,
      keepPreviousData: true,
    }),
  },
);
